import React from "react";
import styled from "styled-components/native";
import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";

type PersonalisationSectionProps = {
  data: Record<string, string>;
};

const PersonalisationSection = ({ data }: PersonalisationSectionProps) => {
  const { theme, t, typography } = useScreenOptionsHooks();

  const formatLabel = (key: string) => {
    if (key.includes(" ") && /[A-Z]/.test(key)) {
      return key;
    }

    return key
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <SectionContainer>
      <HeaderTitle>
        <VDBText color={theme["core-05"]} type={typography["Minor-M"]}>
          {t("orderCart.itemCard.personalisation.text")}
        </VDBText>
      </HeaderTitle>
      {Object.entries(data).map(([key, value], index, array) => (
        <React.Fragment key={index}>
          <Row key={key}>
            <Label>
              <VDBText color={theme["core-06"]} type={typography["Minor-R"]}>
                {formatLabel(key)}:
              </VDBText>
            </Label>
            <Spacer size={SpaceType.Basic} />
            <Value>
              <VDBText color={theme["core-05"]} type={typography["Minor-M"]}>
                {value || "-"}
              </VDBText>
            </Value>
          </Row>
          {index < array.length - 1 && <Spacer size={SpaceType.ExtraSmall} />}
        </React.Fragment>
      ))}
    </SectionContainer>
  );
};

export default PersonalisationSection;

const SectionContainer = styled.View`
  padding: ${SpaceType.Basic}px;
  background-color: ${({ theme }) => theme["core-01"]};
  border-top-width: 1px;
  border-top-color: ${({ theme }) => theme["core-03"]};
`;

const Row = styled.View`
  flex-direction: row;
  justify-content: space-between;
`;

const HeaderTitle = styled.View`
  padding-bottom: ${SpaceType.Basic}px;
`;

const Label = styled.View`
  width: 155px;
`;

const Value = styled.View`
  flex: 1;
`;
